<template>
  <transition name="fade">
    <div v-if="visible" class="fb-overlay">
      <div class="fb-modal" role="dialog" aria-modal="true">
        <template v-if="!sent">
          <h2>Seu teste completo terminou</h2>
          <p class="muted">
            <template v-if="overLimit">
              Sua conta passou para o plano Grátis, que inclui até 50 {{ plural }}: você tem mais que isso, então
              novas anotações vão pedir um plano depois do prazo. Uma pergunta rápida nos ajuda muito:
            </template>
            <template v-else>
              Sua conta segue no plano Grátis, com tudo até 50 {{ plural }}. Uma
              pergunta rápida nos ajuda muito:
            </template>
            <b>o que faltou para você assinar?</b>
          </p>
          <div class="options">
            <label
              v-for="o in options"
              :key="o.value"
              :class="{ selected: answer === o.value }"
            >
              <input v-model="answer" type="radio" :value="o.value" />
              {{ o.label }}
            </label>
          </div>
          <textarea
            v-model="comment"
            rows="2"
            placeholder="Quer contar mais? (opcional)"
          ></textarea>
          <div class="actions">
            <button type="button" class="btn-text" @click="skip">
              Agora não
            </button>
            <button
              type="button"
              class="btn-send"
              :disabled="!answer || sending"
              @click="send"
            >
              Enviar
            </button>
          </div>
        </template>
        <template v-else>
          <h2>Obrigado! 💙</h2>
          <p class="muted">
            Lemos todas as respostas. Se quiser falar com a gente, é só escrever
            para suporte@ordexa.com.br.
          </p>
          <div class="actions">
            <button type="button" class="btn-send" @click="$emit('close')">
              Fechar
            </button>
          </div>
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";

export default {
  name: "ComponentFeedbackModal",
  props: { visible: { type: Boolean, default: false } },
  emits: ["close", "wants-upgrade"],
  data() {
    return {
      answer: null,
      comment: "",
      sending: false,
      sent: false,
      options: [
        { value: "preco", label: "O preço" },
        { value: "pouco_uso", label: "Não usei o suficiente para decidir" },
        {
          value: "falta_funcionalidade",
          label: "Falta uma funcionalidade que eu preciso",
        },
        { value: "gratis_atende", label: "O plano Grátis já me atende" },
        { value: "vou_assinar", label: "Vou assinar em breve" },
        { value: "outro", label: "Outro motivo" },
      ],
    };
  },
  computed: {
    overLimit() {
      const c = this.$store.state.Companies.company || {};
      return (c.paywall_level || 0) > 0;
    },
    plural() {
      return (
        this.$store.getters["Companies/customerTreatmentPlural"] || "Pacientes"
      ).toLowerCase();
    },
  },
  methods: {
    async post(answer, comment) {
      await axios.post("/api/v1/billing/feedback", {
        kind: "trial_end",
        answer,
        comment,
        meta: { contentType: "application/json" },
      });
      this.$store.dispatch("Companies/loadCompany", { force: true }).catch(() => {});
    },
    async send() {
      this.sending = true;
      try {
        await this.post(this.answer, this.comment);
        if (this.answer === "vou_assinar") {
          this.$emit("wants-upgrade");
          return;
        }
        this.sent = true;
      } catch (e) {
        this.$emit("close");
      } finally {
        this.sending = false;
      }
    },
    async skip() {
      try {
        await this.post("pulou", "");
      } catch (e) {
        // ignore
      }
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.fb-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 30, 40, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1900;
  padding: 16px;
}

.fb-modal {
  background: #fff;
  border-radius: 14px;
  max-width: 480px;
  width: 100%;
  padding: 1.7em;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}

.fb-modal h2 {
  margin: 0 0 0.5em;
  font-size: 1.3em;
  color: #222;
}

.muted {
  color: #555;
  line-height: 1.5;
}

.options {
  display: flex;
  flex-direction: column;
  gap: 0.4em;
  margin: 1em 0;
}

.options label {
  border: 1px solid #dde3e6;
  border-radius: 8px;
  padding: 0.6em 0.8em;
  cursor: pointer;
}

.options label.selected {
  border-color: #29b1cc;
  background: #f0fbfd;
}

.options input {
  margin-right: 0.5em;
}

textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #ccd3d8;
  border-radius: 8px;
  padding: 0.6em;
  font-family: inherit;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.8em;
  margin-top: 1em;
}

.btn-text {
  background: none;
  border: none;
  color: #888;
  cursor: pointer;
}

.btn-send {
  background: #29b1cc;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.6em 1.4em;
  font-weight: 700;
  cursor: pointer;
}

.btn-send:disabled {
  opacity: 0.6;
}
</style>
